// The play settings rows in the menu sheet (FE-25, FE-26, FE-10): stick side and size, text size,
// effects and the park's sound. The road is always the 3D street (game/road.ts), so it has no row.
import {
  type Effects,
  type ParkSound,
  type Side,
  type StickSize,
  setPrefs,
  type TextSize,
  usePrefs,
} from '../lib/prefs';
import { S } from '../strings';

export function PlaySettings() {
  const p = usePrefs();
  const chip = (on: boolean, label: string, onClick: () => void) => (
    <button key={label} type="button" className={`chip${on ? ' is-on' : ''}`} aria-pressed={on} onClick={onClick}>
      {label}
    </button>
  );
  return (
    <>
      <li className="sheet__row">
        <span>{S.prefs.side}</span>
        <span className="row">
          {(['left', 'right'] as Side[]).map((h) =>
            chip(p.side === h, S.prefs.sides[h] ?? h, () => setPrefs({ side: h })),
          )}
        </span>
      </li>
      <li className="sheet__row">
        <span>{S.prefs.stick}</span>
        <span className="row">
          {(['s', 'm', 'l'] as StickSize[]).map((k) =>
            chip(p.stick === k, S.prefs.sizes[k] ?? k, () => setPrefs({ stick: k })),
          )}
        </span>
      </li>
      <li className="sheet__row">
        <span>{S.prefs.text}</span>
        <span className="row">
          {(['s', 'm', 'l'] as TextSize[]).map((k) =>
            chip(p.text === k, S.prefs.texts[k] ?? k, () => setPrefs({ text: k })),
          )}
        </span>
      </li>
      <li className="sheet__row">
        <span>{S.prefs.effects}</span>
        <span className="row">
          {(['full', 'calm'] as Effects[]).map((k) =>
            chip(p.effects === k, S.prefs.effectsKinds[k] ?? k, () => setPrefs({ effects: k })),
          )}
        </span>
      </li>
      <li className="sheet__row">
        <span>{S.prefs.parkSound}</span>
        <span className="row">
          {(['on', 'off'] as ParkSound[]).map((k) =>
            chip(p.parkSound === k, S.prefs.parkSounds[k] ?? k, () => setPrefs({ parkSound: k })),
          )}
        </span>
      </li>
    </>
  );
}
